import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subject, distinctUntilChanged, switchMap, takeUntil } from 'rxjs';

import { DomService } from 'ish-core/utils/dom/dom.service';
import { whenTruthy } from 'ish-core/utils/operators';

import { DotCmsFacade } from '../facades/dot-cms.facade';
import { CustomDotCmsPageContainer } from '../models/container/custom-dot-cms-page-container.model';
import { CustomDotCmsContentlet } from '../models/contentlet/custom-dotcms-contentlet.model';

interface DotContainer {
  DotCMSContentlet?: CustomDotCmsContentlet;
  acceptTypes: string;
  identifier: string;
  maxContentlets: number;
  uuid: string;
  variantId?: string;
}

@Directive({
  selector: '[dotCmsContentletEditWrapper]',

  exportAs: 'dotCmsContentletEditWrapper',
})
export class DotCmsContentletEditWrapperDirective implements OnInit, OnDestroy, OnChanges {
  @Input() contentlet: string;
  @Input() container: string;
  @Input() container_uuid: string;
  private container$ = new ReplaySubject<string>(1);
  private contentlet$ = new ReplaySubject<string>(1);
  private destroy$ = new Subject<void>();

  constructor(private dotCmsFacade: DotCmsFacade, private elementRef: ElementRef, private domService: DomService) {}

  ngOnInit(): void {
    this.contentlet$
      .pipe(
        takeUntil(this.destroy$),
        whenTruthy(),
        distinctUntilChanged(),
        switchMap(value => this.dotCmsFacade.getContentletByIdentifier$(value))
      )
      .subscribe(contentlet => this.setContentletDotCmsEditAttributes(contentlet));

    this.container$
      .pipe(
        takeUntil(this.destroy$),
        whenTruthy(),
        distinctUntilChanged(),
        switchMap(value => this.dotCmsFacade.getContainerByIdentifier$(value))
      )
      .subscribe(container => this.setContainerDotCmsEditAttributes(container));
  }

  ngOnChanges(): void {
    this.contentlet$.next(this.contentlet);
    this.container$.next(this.container);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //Todo: Fix code duplication
  private setContentletDotCmsEditAttributes(contentlet: CustomDotCmsContentlet) {
    this.setDataAttribute('data-dot-object', 'contentlet');
    this.setDataAttribute('data-dot-inode', contentlet.inode);
    this.setDataAttribute('data-dot-identifier', contentlet.identifier);
    this.setDataAttribute('data-dot-type', contentlet.contentType);
    this.setDataAttribute('data-dot-basetype', contentlet.baseType);
    this.setDataAttribute('data-dot-lang', String(contentlet.languageId));
    this.setDataAttribute('data-dot-title', contentlet.title);
    this.setDataAttribute('data-dot-can-edit', 'true');

    //UVE
    this.setDataAttribute('data-testid', 'dot-contentlet');
    this.setDataAttribute('data-dot-on-number-of-pages', contentlet.onNumberOfPages?.toString());

    //this.setDataAttribute('data-dot-content-type-id', this.contentlet);
    this.setDataAttribute('data-dot-has-page-lang-version', 'true');
  }

  private setContainerDotCmsEditAttributes(pageContainer: CustomDotCmsPageContainer) {
    const dotContainer: DotContainer = {
      acceptTypes: pageContainer?.containerStructures.map(structure => structure.contentTypeVar).join(','),
      identifier: pageContainer.container?.path || pageContainer.container?.identifier,
      maxContentlets: pageContainer.container?.maxContentlets,
      uuid: this.container_uuid,
      variantId: pageContainer.container?.parentPermissionable?.variantId,
    };
    this.setDataAttribute('data-dot-container', JSON.stringify(dotContainer));
  }

  //  <div
  //               data-testid="dot-contentlet"
  //               data-dot-object="contentlet"
  //               [attr.data-dot-identifier]="contentlet.identifier"
  //               [attr.data-dot-basetype]="contentlet.baseType"
  //               [attr.data-dot-title]="contentlet['widgetTitle'] || contentlet.title"
  //               [attr.data-dot-inode]="contentlet.inode"
  //               [attr.data-dot-type]="contentlet.contentType"

  //               [attr.data-dot-container]="dotContainerAsString()"
  //               [attr.data-dot-on-number-of-pages]="contentlet['onNumberOfPages']">
  //Todo: Fix code duplication
  setDataAttribute(key: string, value: string) {
    if (!!key && !!value) this.domService.setAttribute(this.elementRef.nativeElement, key, value);
  }
}
